import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useToken } from '@autobid/nuxt-auth/src/composables/useToken'
import * as Sentry from '@sentry/nuxt'
import { watch } from 'vue'

export const useSetSentryUser = () => {
  const { isAuthed } = useAutobidAuth()
  const { tokenData } = useToken()

  const setSentryUser = () => {
    if (!isAuthed.value || !tokenData.value) {
      Sentry.setUser(null)
      return
    }

    const { id, nickname: username } = tokenData.value
    Sentry.setUser({ id, username })
  }

  watch(isAuthed, setSentryUser)

  return setSentryUser
}